import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import enzymes from './enzymes/index.vue'
import molecules from './molecules/index.vue'
import pawns from './pawns/index.vue'
import turn from './turn/index.vue'
import { mixins } from 'vue-class-component'
import MixinGame from '@/mixins/game'


@Component({
  components: {
    'vgb-enzymes': enzymes,
    'vgb-molecules': molecules,
    'vgb-pawns': pawns,
    'vgb-turn': turn,
  },
})
export default class Stock extends mixins(MixinGame) {

}
